import { API } from './interceptor'

export async function fetchSpartacusData(queryParams) {
  const response = await API.get('api2', 'spartacus/data', {
    queryStringParameters: queryParams,
  })

  if (!response?.success) {
    throw new Error(response?.message || 'Failed to load Spartacus data')
  }

  return response.data
}

export async function fetchSpartacusVenues(queryParams) {
  const response = await API.get('api2', 'spartacus/venues', {
    queryStringParameters: queryParams,
  })

  if (!response?.success) {
    throw new Error(response?.message || 'Failed to load Spartacus venues')
  }

  return response.data
}

export async function fetchSpartacusStats(queryParams) {
  const response = await API.get('api2', 'spartacus/stats', {
    queryStringParameters: queryParams,
  })

  if (!response?.success) {
    throw new Error(response?.message || 'Failed to load Spartacus stats')
  }

  return response.data
}

export async function fetchSpartacusPresets() {
  const response = await API.get('api2', 'spartacus/presets')

  if (!response?.success) {
    throw new Error(response?.message || 'Failed to load Spartacus presets')
  }

  return response.data?.presets || []
}

export async function fetchSpartacusVenueUsers(venueId) {
  const response = await API.get('api2', `spartacus/venues/${venueId}/users`)

  if (!response?.success) {
    throw new Error(response?.message || 'Failed to load venue users')
  }

  return response.data
}

export async function fetchSpartacusVenueNotes(venueId, queryParams = {}) {
  const response = await API.get('api2', `spartacus/venues/${venueId}/notes`, {
    queryStringParameters: queryParams,
  })

  if (!response?.success) {
    throw new Error(response?.message || 'Failed to load venue notes')
  }

  return response.data
}

export async function createSpartacusVenueNote(venueId, body) {
  const response = await API.post('api2', `spartacus/venues/${venueId}/notes`, {
    body,
  })

  if (!response?.success) {
    throw new Error(response?.message || 'Failed to create venue note')
  }

  return response.data
}

export async function updateSpartacusVenueNote(venueId, noteId, body) {
  const response = await API.patch(
    'api2',
    `spartacus/venues/${venueId}/notes/${noteId}`,
    {
      body,
    },
  )

  if (!response?.success) {
    throw new Error(response?.message || 'Failed to update venue note')
  }

  return response.data
}

export async function setSpartacusVenueNotePinned(venueId, noteId, pinned) {
  const response = await API.patch(
    'api2',
    `spartacus/venues/${venueId}/notes/${noteId}/pin`,
    {
      body: { pinned: Boolean(pinned) },
    },
  )

  if (!response?.success) {
    throw new Error(response?.message || 'Failed to update note pin state')
  }

  return response.data
}

export async function exportSpartacusVenues(queryParams) {
  const response = await API.get('api2', 'spartacus/export', {
    queryStringParameters: queryParams,
  })

  if (!response?.success) {
    throw new Error(response?.message || 'Failed to export Spartacus venues')
  }

  return response.data
}
